export class CheckboxGroupCtrl {
  public toggle: () => void;
  public disabled: () => boolean;
}
